import router from "@/router";
import store from "../store";
// import { isWechatBrowser } from "@/utils/wx-utils";
import { NoAuthRouter } from "@/router";
import { getType } from "../utils/auth";

import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
  const state = store.state;
  const token = state.user.token;
  if (token) {
    if (to.meta.type == "both") {
      next();
    } else if (getType() == to.meta.type) {
      if (getType() == "user") {
        if (to.path === "/login" && !to.query.authId) {
          next({ path: "/" }); // 已经登录的不再登录
        } else {
          next();
        }
      } else {
        if (to.path === "/traderLogin" && !to.query.authId) {
          next({ path: "/salesman/index" }); // 已经登录的不再登录
        } else {
          next();
        }
      }
    } else if (getType() != to.meta.type) {
      if (getType() == "user") {
        next({ path: "/login" });
      } else {
        next({ path: "/traderLogin" });
      }
    }

    // if (getUser() == "user") {
    //   if (to.path === "/login" && !to.query.authId) {
    //     next({ path: "/" }); // 已经登录的不再登录
    //   } else {
    //     next();
    //   }
    // } else {
    //   if (to.path === "/traderLogin" && !to.query.authId) {
    //     next({ path: "/salesman/index" }); // 已经登录的不再登录
    //   } else {
    //     next();
    //   }
    // }
  } else {
    if (NoAuthRouter(to.path)) {
      next();
    } else {
      // if (isWechatBrowser()) {
      //   next(`/wechatauth?redirect=${from.fullPath}`);
      // } else {
      next(`/login?redirect=` + to.fullPath);
      // next(`/login?redirect=${from.fullPath}`);
      // }
    }
  }
});

router.afterEach(() => {});
